import {useContext} from 'react'

import {DragAndDropItemContext} from '../context/DragAndDropItemContext'

export const useDragAndDropItem = () => {
  const context = useContext(DragAndDropItemContext)
  if (!context) {
    throw new Error('useDragAndDropItem must be used within a DragAndDropItemContextProvider')
  }
  return context
}
